import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { displayErrorToast, displaySuccessToast } from '~reducers/toast/action';

function useDisplayToast() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const displayToast = useCallback(
    (type, payload) => {
      switch (type) {
        case 'success': {
          dispatch(displaySuccessToast(payload));
          break;
        }
        case 'success-updated': {
          dispatch(displaySuccessToast(t('toast.info.success.updated', { entity: payload })));
          break;
        }
        case 'success-uploaded': {
          dispatch(displaySuccessToast(t('toast.info.success.uploaded', { entity: payload })));
          break;
        }
        case 'success-created': {
          dispatch(displaySuccessToast(t('toast.info.success.created', { entity: payload })));
          break;
        }
        case 'success-checked-in': {
          dispatch(displaySuccessToast(t('toast.info.success.checked_in')));
          break;
        }
        case 'success-checked-out': {
          dispatch(displaySuccessToast(t('toast.info.success.checked_out')));
          break;
        }
        case 'success-cancelled': {
          dispatch(displaySuccessToast(t('toast.info.success.cancelled', { entity: payload })));
          break;
        }
        case 'success-generated': {
          dispatch(displaySuccessToast(t('toast.info.success.generated', { entity: payload })));
          break;
        }
        case 'success-held': {
          dispatch(displaySuccessToast(t('toast.info.success.held', { entity: payload })));
          break;
        }
        case 'success-released': {
          dispatch(displaySuccessToast(t('toast.info.success.released', { entity: payload })));
          break;
        }
        case 'success-amended': {
          dispatch(displaySuccessToast(t('toast.info.success.amended')));
          break;
        }
        case 'success-added': {
          dispatch(displaySuccessToast(t('toast.info.success.added', { entity: payload })));
          break;
        }
        case 'success-removed': {
          dispatch(displaySuccessToast(t('toast.info.success.removed', { entity: payload })));
          break;
        }
        case 'success-linked': {
          dispatch(displaySuccessToast(t('toast.info.success.linked', { entity: payload })));
          break;
        }
        case 'success-unlinked': {
          dispatch(displaySuccessToast(t('toast.info.success.unlinked', { entity: payload })));
          break;
        }
        case 'success-deleted': {
          dispatch(displaySuccessToast(t('toast.info.success.deleted', { entity: payload })));
          break;
        }
        case 'success-closed': {
          dispatch(displaySuccessToast(t('toast.info.success.closed', { entity: payload })));
          break;
        }

        case 'error': {
          dispatch(displayErrorToast(payload));
          break;
        }

        default: {
          break;
        }
      }
    },
    [dispatch, t]
  );

  return displayToast;
}

export default useDisplayToast;
